import { render, staticRenderFns } from "./ComboboxMunicipioTerritorios.vue?vue&type=template&id=a2ed4ea4"
import script from "./ComboboxMunicipioTerritorios.vue?vue&type=script&lang=js"
export * from "./ComboboxMunicipioTerritorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports